import { customElement } from 'lit/decorators.js';
import { connect } from "pwa-helpers";
import store from "../../../store/store";
import {
  calculateFreight,
  calculateTax,
  getFreightCalculationError,
  getFreightCalculationStatus,
  getTaxCalculationError,
  getTaxCalculationStatus,
  isShippingAddressValid, updateSelectedShippingMethod
} from "../shop-checkout";
import { ShippingMethodCheckoutStepBase } from "../shipping-method-checkout-step-base";
import { StoreState } from '../../../store/store.interface';
import { ActionStatus } from '../../../common/constants/action-status';
import { handleApiError } from '../../../common/utils/api-utils';

/**
 * Checkout Step to load shipping method options given shipping address. 
 * Save selected method in redux shop checkout state.
 */
@customElement('mhecomm-shipping-method-k12-storefront-checkout-step')
export class ShippingMethodK12StorefrontCheckoutStep extends connect(store)(ShippingMethodCheckoutStepBase){

  stateChanged(state: StoreState) {
    this.canEditStep(state);

    this.handleApiFailures(state);
    this.isLoading = getFreightCalculationStatus(state) === ActionStatus.loading;
    if(getFreightCalculationStatus(state) === ActionStatus.succeeded) {
      this.onFreightCalculationResponse(state);
    }
  }

  override handleApiFailures(state: StoreState){
    if (getTaxCalculationStatus(state) === ActionStatus.failed) {
      handleApiError(getTaxCalculationError(state));
      return;
    }
    if (getFreightCalculationStatus(state) === ActionStatus.failed) {
      handleApiError(getFreightCalculationError(state));
      return;
    }
  }

  /**
   * On click continue to next checkout step, validate that user has selected a shipping method.
   * After successful validation, save selected method in redux shop checkout state.
   */
  override async stepDoValidation() {
    await super.stepDoValidation();
    await store.dispatch(calculateTax()).unwrap();
  }

  /**
   * This step is the last step in K12.
   * So, when it is being forced to complete, we should calculate the tax.
   */
  async forceCompleteStep() {
    await super.forceCompleteStep();
    await store.dispatch(calculateTax()).unwrap();
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'mhecomm-shipping-method-k12-storefront-checkout-step': ShippingMethodK12StorefrontCheckoutStep;
  }
}

